<template>
  <v-app>
    <app-toolbar/>
    <v-main
      class="full-height"
      :class="{ 'v-main--with-toolbar': mainWithToolbarOffset }"
    >
      <router-view></router-view>
    </v-main>
    <g-snackbar ref="snack" />
  </v-app>
</template>

<script>
  import GlobalSnackbar from './components/Shared/GlobalSnackbar.vue'
  import getLanguage from './lib/get-language'
  import { trackEvent } from './lib/track-events'
  import { EVENTS_TO_TRACK } from './constants/const'
  import { isToolbarVisibleForRoute } from './lib/toolbarVisibility'
  export default {
    data () {
      return {
      }
    },
    computed: {
      mainWithToolbarOffset () {
        return isToolbarVisibleForRoute(this.$route)
      }
    },
    created () {
      gtag('event', 'open_app', {event_category: 'action', event_label: 'Open app'})
      if (window.navigator.onLine) {
        this.$store.commit('setIsOnline', true)
      } else {
        this.$store.commit('setIsOnline', false)
      }
      this.$i18n.locale = getLanguage()
    },
    mounted () {
      this.$root.snack = this.$refs.snack
      trackEvent(EVENTS_TO_TRACK.OPEN_APP)
    },
    components: {
      'g-snackbar': GlobalSnackbar
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'
</style>



// WEBPACK FOOTER //
// App.vue?a05ba208